"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberIsInteger = void 0;

var NumberIsInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

exports.NumberIsInteger = NumberIsInteger;